import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const tooltip = css`
  ${breakpoint.up('smMd')} {
    max-width: 275px;
  }
`

export const promo = (theme: Theme) => css`
  margin: ${size[16]} 0;
  padding: ${size[16]};
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${size[16]};
  user-select: text;
  cursor: text;

  background-color: ${theme.palette.background.main};
  border: none;
  border-radius: ${size[8]};
  box-shadow: 0px 9px 39px 0px #1d06281a;
  color: ${theme.palette.primary.mainContrast};

  p {
    font-size: ${pxToRem(18)};
    font-weight: 500;
  }

  ${breakpoint.up('smMd')} {
    max-width: 275px;
  }
`

export const clickable = css`
  cursor: pointer;
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
  font-weight: 700;
`
